import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type SupportRoleConfig = typeof SupportRoleConfig._.Config;

export const SupportRoleConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.SupportRole,
  configSchema: z.object({}),
});
